import type {
  ProgressionSchema,
  ExerciseDetailsProgression,
} from '~/types/schema';

export type UseProgressionExercises = {
  ids: Ref<string[]>;
  progressions: Ref<ProgressionSchema[]>;
  getProgressIds: (ids: string[]) => number;
};

export const INJECT_PROGRESSION_EXERCISES = Symbol(
  'useProgressionExercises composable'
) as InjectionKey<UseProgressionExercises>;

export const useProgressionExercises = (
  contentMemberId,
  categoryManager
): UseProgressionExercises => {
  const { progressions: syncProgressions, ids } = useProgressionsSyncGet(
    toValue(contentMemberId),
    'exercise'
  );

  const associatedIds = computed(() => {
    return (
      toRaw(categoryManager.associatedIds.value) || {
        postsIds: [],
        exerciseIds: [],
      }
    );
  });

  const associatedExerciseIds = computed(() => {
    return toRaw(associatedIds.value).exerciseIds || [];
  });

  const progressions = ref<ProgressionSchema[]>([]);

  const getProgressIds = (ids) => {
    const total = ids.length;
    if (!progressions.value) return 0;
    const current = progressions.value.reduce((acc, progression) => {
      const data = progression.data as ExerciseDetailsProgression;
      if (data.status === 'done') return acc + 1;
      return acc;
    }, 0);
    return current / total;
  };

  watchEffect(() => (ids.value = associatedExerciseIds.value));

  watch(
    () => syncProgressions.value,
    (pr) => {
      progressions.value = [...toRaw(pr)];
    }
  );

  return {
    ids,
    progressions,
    getProgressIds,
  };
};
